import * as validators from '@vuelidate/validators'
import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        validations: {
            required: "The field is required",
            email: "Invalid format email",
            maxLength: "The field must have a max length of {max}"
        }
    },
    es: {
        validations: {
            required: "El campo es obligatorio",
            email: "Email inválido",
            maxLength: "El campo debe tener {max} caracteres máximo"
        }
    }
}

const { createI18nMessage } = validators
const i18n = createI18n({ legacy: false, locale: 'es', fallbackLocale: 'en', messages })


const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) })


export const required = withI18nMessage(validators.required)
export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true })
export const email = withI18nMessage(validators.email)
